import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsAcceleratorsService } from '../../admissions-accelerators.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'admissions-accelerators-teams-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './teams-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./teams-view.part.scss'],
})
export class AdmissionsTeamsViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AdmissionsAcceleratorsService);
	public readonly admissionsAreaService = inject(AdmissionsAreaService);

	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});
}